import React, { useState, useMemo } from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import NestedMenuItem from "material-ui-nested-menu-item";
import { IconButton } from "@material-ui/core";
import { useMenuClasses, useMenuItemClasses } from '../Navigator/TreeContextMenu';
import Divider from "@material-ui/core/Divider";

const HamburgerMenu = ({ menuItems }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const menuClasses = useMenuClasses();
    const menuItemClasses = useMenuItemClasses();
    const mainMenuItems = menuItems(); // useMemo(() => menuItems ? menuItems() : [], []);

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const itemClick = (item) => {
        item.handler(item);
        handleClose();
    };

    const MenuEntry = React.forwardRef((props, ref) => {
        const { item, open } = props;
        return (
            (item.divider ? (
                <Divider/>
            ) : (item.submenu ? (
                <NestedMenuItem classes={menuItemClasses} label={item.label} parentMenuOpen={open}>
                    {item.submenu.map(subitem => <MenuEntry key={subitem.label} item={subitem} open={open}/>)}
                </NestedMenuItem>
            ) : (
                <MenuItem
                    classes={menuItemClasses}
                    disabled={item.disabled}
                    onClick={() => itemClick(item)}>{item.contents || item.label}
                </MenuItem>
            )))
        );
    });

    const MainMenu = React.forwardRef((props, ref) => {
        const { menuItems } = props;
        return (
            <Menu
                classes={menuClasses}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                // anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: -30, 'horizontal': -2 }}
            >
                { menuItems.map((item, i) => <MenuEntry key={i} item={item} open={!!anchorEl} /> )}
            </Menu>
        );
    });

    return (
        <>
            <IconButton style={{padding: '4px 8px'}} edge="start" onClick={handleClick} >
                <MenuIcon />
            </IconButton>
            <MainMenu menuItems={mainMenuItems} />
        </>
    );
};

export default HamburgerMenu;
